var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLegislativeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 91 87",
    style: {
      enableBackground: "new 0 0 91 87"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#D2B859;}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#354154;}\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:#35B0CB;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group-20"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-1",
    className: "st0",
    d: "M33.9,65.4c-0.8,0-1.5-0.2-2-0.3c-0.6-0.1-1.1-0.3-1.7-0.5v-3c1,0.4,1.4,0.5,2.4,0.7 c1.1,0.2,1.9,0.3,2.7,0.3c1.3,0,2.4-0.4,3.2-1.1c0.8-0.7,1.2-1.6,1.2-2.7c0-0.7-0.1-1.3-0.3-1.8s-0.5-1-1-1.3 c-0.4-0.3-1.3-0.8-2.7-1.5l-2-0.9c-1.7-0.8-2.9-1.7-3.6-2.7c-0.7-1.1-1-2.3-1-3.8s0.5-2.9,1.5-4s2-1.6,3.4-2V38h3.2v2.6 c1.5,0,2.7,0.5,3.6,1v3.1c-0.5-0.3-1.1-0.6-2.1-0.9c-0.9-0.3-1.8-0.4-2.6-0.4c-1.2,0-2.1,0.3-2.7,1c-0.7,0.6-1,1.5-1,2.5 c0,0.6,0.1,1.2,0.4,1.7c0.2,0.5,0.6,0.9,1,1.3c0.4,0.4,1.3,0.8,2.6,1.4L38,52c1.8,0.8,3.1,1.8,3.9,2.9c0.8,1.2,1.2,2.6,1.2,4.5 c0,1.5-0.5,2.8-1.6,3.9c-1.1,1.1-2.3,1.7-4.2,2.1v2.8H34L33.9,65.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-3",
    className: "st1",
    d: "M36,87C6.3,87,0,72.6,0,60.5c0-7.4,2.6-15,7.3-21.3l13.8-18.6c0.3-0.4,0.7-0.6,1.1-0.6h27.6 c0.5,0,0.9,0.2,1.1,0.6l9.7,13.1c0.5,0.6,0.389,2.367-0.3,2c-0.896-0.477-1.5,0.3-2-0.3L49,22.9H23l-13.4,18 c-4.3,5.8-6.7,12.8-6.7,19.6C2.9,76,14.4,84.1,36,84.1c11.3,0,16.1-0.2,16.1-0.2c0.8-0.1,1.5,0.6,1.5,1.4s-0.6,1.5-1.4,1.5 C52.1,86.8,47.4,87,36,87"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-5",
    className: "st1",
    d: "M21.2,16.7c-0.2,0-0.4,0.2-0.4,0.3v2c0,0.2,0.1,0.3,0.3,0.3h29.7c0.2,0,0.3-0.1,0.3-0.3v-2 c0-0.2-0.1-0.3-0.3-0.3H21.2z M50.8,22H21.2c-1.8,0-3.2-1.4-3.2-3v-2c0-1.7,1.4-3,3.2-3h29.7c1.7,0,3.1,1.4,3.1,3v2 C54,20.6,52.6,22,50.8,22L50.8,22z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-9",
    className: "st1",
    d: "M53.9,84.1h34.2V35.9H53.9V84.1z M89.6,87H52.4c-0.8,0-1.4-0.6-1.4-1.4V34.4 c0-0.8,0.6-1.4,1.4-1.4h37.1c0.8,0,1.4,0.6,1.4,1.4v51.1C91,86.4,90.4,87,89.6,87L89.6,87z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-11",
    className: "st2",
    d: "M82.7,40H59.3c-0.7,0-1.3,0.6-1.3,1.3v5.4c0,0.7,0.6,1.3,1.3,1.3h23.5c0.7,0,1.3-0.6,1.3-1.3 v-5.4C84,40.6,83.4,40,82.7,40"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-12",
    className: "st1",
    d: "M59.075,78.2h23.3V55.8h-23.3V78.2z M83.875,81h-26.2c-0.8,0-1.4-0.6-1.4-1.4V54.4 c0-0.8,0.6-1.4,1.4-1.4h26.2c0.8,0,1.4,0.6,1.4,1.4v25.2C85.275,80.4,84.675,81,83.875,81L83.875,81z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-13",
    className: "st1",
    d: "M64.5,81c-0.8,0-1.5-0.6-1.5-1.4V60.4c0-0.8,0.7-1.4,1.5-1.4c0.8,0,1.5,0.6,1.5,1.4v19.1 C66,80.4,65.3,81,64.5,81"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-14",
    className: "st1",
    d: "M70.5,81c-0.8,0-1.5-0.6-1.5-1.4V54.4c0-0.8,0.7-1.4,1.5-1.4s1.5,0.6,1.5,1.4v25.2 C72,80.4,71.3,81,70.5,81"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-15",
    className: "st1",
    d: "M77.5,81c-0.8,0-1.5-0.6-1.5-1.4V54.4c0-0.8,0.7-1.4,1.5-1.4s1.5,0.6,1.5,1.4v25.2 C79,80.4,78.3,81,77.5,81"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "Fill-16",
    className: "st1",
    d: "M83.875,62h-26.2c-0.8,0-1.4-0.7-1.4-1.5s0.6-1.5,1.4-1.5h26.2c0.8,0,1.4,0.7,1.4,1.5 S84.675,62,83.875,62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-17",
    className: "st1",
    d: "M83.875,69h-26.2c-0.8,0-1.4-0.7-1.4-1.5s0.6-1.5,1.4-1.5h26.2c0.8,0,1.4,0.7,1.4,1.5 S84.675,69,83.875,69"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-18",
    className: "st1",
    d: "M83.875,75h-26.2c-0.8,0-1.4-0.7-1.4-1.5s0.6-1.5,1.4-1.5h26.2c0.8,0,1.4,0.7,1.4,1.5 S84.675,75,83.875,75"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Fill-19",
    className: "st0",
    d: "M20.6,75c-4.2-0.6-7.3-2.4-9.3-5.4C7.6,64,9.5,56.3,9.6,56l2.8,0.7L11,56.4l1.4,0.4 c0,0.1-1.7,6.8,1.4,11.4c1.5,2.2,3.9,3.6,7.3,4.1L20.6,75z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M59.6,5.6l-3.4-3.3c-3.1-3-8.1-3-11.2,0L43.5,4l-0.2-0.2c-1.8-1.7-4.1-2.7-6.7-2.7c-2.6,0-4.9,0.9-6.7,2.7 L29.7,4L28,2.3c-3.1-3-8.1-3-11.2,0l-3.4,3.3c-0.3,0.2-0.4,0.6-0.4,1s0.2,0.8,0.4,1l9.4,9c0.04,0.04,0.08,0.067,0.12,0.1h27.16 c0.04-0.033,0.08-0.06,0.12-0.1l9.4-9C59.8,7.3,60,7,60,6.6S59.9,5.9,59.6,5.6z M48.6,14.1H24.4l-7.9-7.5l2.4-2.3 c2-1.9,5.1-1.9,7.1,0L28.7,7c0.5,0.6,1.4,0.6,2,0L32,5.8c1.2-1.2,2.9-1.9,4.6-1.9c1.7,0,3.4,0.7,4.6,1.9L42.4,7 c0.5,0.6,1.4,0.6,2,0l2.7-2.7c2-1.9,5.1-1.9,7.1,0l2.3,2.3L48.6,14.1z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLegislativeIcon);
export default __webpack_public_path__ + "static/media/Legislative-Icon.abd9561a56bf31746d4fa1183f6a4e08.svg";
export { ForwardRef as ReactComponent };